import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  LoadingSpinner,
  ButtonMode,
  ButtonSize,
  PagePanel,
  Box
} from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';

import { Form } from '@epi-components/Form';
import { ResetPasswordField } from '@epi-forms/controls/ResetPasswordField';
import { IResetPassword } from '@epi-models/containers/ResetPassword';

import history from '../../routes/history';
import { isLoading as isLoadingSelector } from '../../selectors/saga';
import { ApiConstants } from '../../constants/actions';
import * as apiActions from '../../actions/api';

import './ResetPassword.scss';

const ResetPasswordWrapper = styled.div`
  padding-top: 10px;
`;

function ResetPassword({
  resetPassword,
  isLoading,
  submitting
}: IResetPassword) {
  const { t } = useTranslation();

  const submitForm = values => {
    resetPassword(values.usernameOrEmail);
  };

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      usernameOrEmail: ''
    }
  });

  const {
    formState: { isValid }
  } = form;

  return (
    <ResetPasswordWrapper>
      <Box px={30}>
        <PagePanel title={t('containers.reset_password.page_title')}>
          <div className="ResetPassword">
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <Form form={form} onSubmit={submitForm}>
                <h2 className="small">
                  <p>{t('containers.reset_password.page_body')}</p>
                </h2>
                <ResetPasswordField />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  gap={10}
                  mt={3}
                >
                  <Button
                    id="reset-password-back-btn"
                    type="button"
                    onClick={history.goBack}
                    fullWidth
                    mode={ButtonMode.Secondary}
                    size={ButtonSize.Medium}
                  >
                    {t('containers.reset_password.back_button')}
                  </Button>
                  <Button
                    id="reset-password-confirm-btn"
                    disabled={submitting || !isValid || isLoading}
                    type="submit"
                    fullWidth
                    mode={ButtonMode.Secondary}
                    size={ButtonSize.Medium}
                  >
                    {t('containers.reset_password.send_button')}
                  </Button>
                </Box>
              </Form>
            )}
          </div>
        </PagePanel>
      </Box>
    </ResetPasswordWrapper>
  );
}

const mapStateToProps = state => ({
  isLoading: isLoadingSelector([ApiConstants.RESET_PASSWORD])(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...apiActions }, dispatch);

const ConnectedResetPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);

export { ConnectedResetPassword as ResetPassword };
